import React, { useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useBottomScrollListener } from "react-bottom-scroll-listener";
import Home from "../Home";
import Breadcrumb from "../../components/Breadcrumb";
import Maintenance from "../Maintenance";
import { Accordion, Card, Spinner } from "react-bootstrap";
import { Select, Modal } from "antd";
import {
  fetchCityList,
  fetchBranchList,
  fetchBUList,
  fetchDivisionList,
  fetchSalesOfficeList,
} from "../OrganizationCustomer/actions";
import {
  fetchMRList,
  getMarketAuthList,
  getChildFacilityList,
  getParentFacilityList,
  getConfigurableParentFacilityList,
  saveParentChildFacilityChange,
} from "./actions";

import errorMessages from "../../common/errorMessages";

// Modal width constants
const MODAL_WIDTH = {
  SMALL: 400,   // Small notification dialogs
  MEDIUM: 600,  // Medium forms
  LARGE: 1200,  // Large forms with multiple fields
};

function ParentChildFacility() {
  const [show, setShow] = useState(false);

  const [lang] = useTranslation("language");

  const [prefectureList, setPrefectureList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [buList, setBuList] = useState([]);
  const [divisionList, setDivisionList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [salesOfficeList, setSalesOfficeList] = useState([]);
  const [mrList, setMRList] = useState([]);
  const [modalMRList, setModalMRList] = useState([]);
  const [facilitySearchList, setFacilitySearchList] = useState([]);
  const [modalFacilitySearchList, setModalFacilitySearchList] = useState([]);
  const [parentFacilityList, setParentFacilityList] = useState([]);
  const [modifiedFacilityList, setModifiedFacilityList] = useState([]);
  const [marketListing, setMarketListing] = useState([]);
  const [updatedFacility, setUpdatedFacility] = useState("");
  const [deleteFacilityId, setDeleteFacilityId] = useState("");
  const [total, setTotal] = useState();
  const [facilityLabel, setFacilityLabel] = useState("selected-mrs");

  const [showFacilityData, setShowFacilityData] = useState("card-hide");
  const [prefectureID, setPrefectureID] = useState("");
  const [prefectureName, setPrefectureName] = useState("");
  const [cityID, setCityID] = useState("");
  const [cityName, setCityName] = useState("");
  const [buID, setBuID] = useState("");
  const [branchID, setBranchID] = useState("");
  const [divisionID, setDivisionID] = useState("");
  const [salesOfficeID, setSalesOfficeID] = useState("");
  const [buName, setBuName] = useState("");
  const [branchName, setBranchName] = useState("");
  const [divisionName, setDivisionName] = useState("");
  const [salesOfficeName, setSalesOfficeName] = useState("");
  const [mrID, setMRID] = useState("");
  const [mrName, setMRName] = useState("");
  const [facilityName, setFacilityName] = useState("");
  const [cusCode, setCusCode] = useState("");
  const [lazyLoading, setLazyLoading] = useState(false);
  const [limit, setLimit] = useState(40);
  const [loading, setLoading] = useState();
  const [resultLoading, setResultLoading] = useState(false);
  const [parentFacilityLoading, setParentFacilityLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);
  const [facilityTotal, setFacilityTotal] = useState(0);
  const [errors, setErrors] = useState({});
  const [noData, setNoData] = useState(false);
  const [noParentFacilityData, setNoParentFacilityData] = useState(false);
  const [modalTotal, setModalTotal] = useState();
  const [successShow, setSuccessShow] = useState(false);
  const [showError, setShowError] = useState(false);
  const [eventKey, setEventKey] = useState("0");
  const [maintenance, setMaintenance] = useState(false);

  const [buLoading, setBULoading] = useState(false);
  const [divisionLoading, setDivisionLoading] = useState(false);
  const [branchLoading, setBranchLoading] = useState(false);
  const [salesOfficeLoading, setSalesOfficeLoading] = useState(false);
  const [mrLoading, setMRLoading] = useState(false);
  const [cityLoading, setCityLoading] = useState(false);

  const [modalBuLoading, setModalBULoading] = useState(false);
  const [modalDivisionLoading, setModalDivisionLoading] = useState(false);
  const [modalBranchLoading, setModalBranchLoading] = useState(false);
  const [modalSalesOfficeLoading, setModalSalesOfficeLoading] = useState(false);
  const [modalMRLoading, setModalMRLoading] = useState(false);
  const [modalCityLoading, setModalCityLoading] = useState(false);

  const [modalPrefectureID, setModalPrefectureID] = useState("");
  const [modalPrefectureName, setModalPrefectureName] = useState("");
  const [modalCityID, setModalCityID] = useState("");
  const [modalCityName, setModalCityName] = useState("");
  const [modalBuID, setModalBuID] = useState("");
  const [modalBranchID, setModalBranchID] = useState("");
  const [modalDivisionID, setModalDivisionID] = useState("");
  const [modalSalesOfficeID, setModalSalesOfficeID] = useState("");
  const [modalBuName, setModalBuName] = useState("");
  const [modalBranchName, setModalBranchName] = useState("");
  const [modalDivisionName, setModalDivisionName] = useState("");
  const [modalSalesOfficeName, setModalSalesOfficeName] = useState("");
  const [modalMrID, setModalMRID] = useState("");
  const [modalMrName, setModalMRName] = useState("");
  const [modalFacilityName, setModalFacilityName] = useState("");
  const [modalCustomerCode, setModalCustomerCode] = useState("");
  const [modalLazyLoading, setModalLazyLoading] = useState(false);
  const [modalLimit, setModalLimit] = useState(30);
  const [modalLoading, setModalLoading] = useState();
  const [modalFacilityTotal, setModalFacilityTotal] = useState(0);
  const [modalErrors, setModalErrors] = useState({});
  const [noModalData, setNoModalData] = useState(false);
  const [facilityLazyLoadData, setFacilityLazyLoadData] = useState({});
  const [modalFacilityLazyLoadData, setModalFacilityLazyLoadData] = useState(
    {}
  );

  const [showOrgId, setShowOrgId] = useState("");
  const [showOrgCode, setShowOrgCode] = useState("");
  const [showOrgName, setShowOrgName] = useState("");
  const [role, setRole] = useState("");

  const routes = [
    {
      name: `${lang("Menu.home")}`,
      path: "/",
    },
    {
      name: `${lang("Menu.parentChildFacility")}`,
      path: "",
    },
  ];

  useEffect(() => {
    const state = sessionStorage.getItem("Prefecture");
    const bu = sessionStorage.getItem("BU");
    const role = sessionStorage.getItem("User role");
    !sessionStorage.getItem("BU") && getBUList();
    setPrefectureList(JSON.parse(state));
    setBuList(JSON.parse(bu));
    setRole(role);
    getMarketAuthListing();
  }, []);

  /*** 
  @purpose : Get BU list
  @Parameter : {}
  **/
  const getBUList = async () => {
    await fetchBUList().then((res) => {
      let newList = [];
      for (let index = 0; index < res.length; index++) {
        const item = res[index];
        newList.push({ value: item.buID, label: item.orgName });
      }
      sessionStorage.setItem("BU", JSON.stringify(newList));
      setBuList(newList);
    });
  };

  /*** 
  @purpose : Get wholesaler group list
  @Parameter : {}
  **/
  const getMarketAuthListing = async () => {
    await getMarketAuthList().then((response) => {
      if (response.maintenanceWindowFlag) {
        setMaintenance(true);
      }
      let list = [];
      response &&
        response.data &&
        response.data.map((item) => {
          list.push(item.maID);
        });
      setMarketListing(list);
    });
  };

  const modalShow = (fac) => {
    setShow(true);
    setUpdatedFacility(fac);
  };
  const handleClose = () => {
    setModalLoading(false);
    setModalFacilitySearchList([]);
    setNoModalData(false);
    setModalFacilityTotal();
    setModalBuID("");
    setModalBuName("");
    setModalDivisionID("");
    setModalDivisionName("");
    setModalBranchID("");
    setModalBranchName("");
    setModalSalesOfficeID("");
    setModalSalesOfficeName("");
    setModalMRID("");
    setModalMRName("");
    setModalFacilityName("");
    setModalCustomerCode("");
    setModalErrors({});
    setShow(false);
  };

  /*** 
  @purpose : Handle State change
  @Parameter : {value}
  **/
  const handleStateChange = async (value) => {
    setCityLoading(true);
    if (value) {
      setPrefectureID(value.value);
      setPrefectureName(value.label);
      await fetchCityList(value.value).then((res) => {
        setCityLoading(false);
        let newCity = [];
        for (let index = 0; index < res.length; index++) {
          const cityOne = res[index];
          newCity.push({ value: cityOne.cityID, label: cityOne.cityName });
        }
        setCityList(newCity);
      });
    } else {
      setCityLoading(false);
      setPrefectureID("");
      setPrefectureName("");
      setCityID("");
      setCityName("");
    }
  };

  /*** 
  @purpose : Handle city change
  @Parameter : {value}
  **/
  const handleCityChange = async (value) => {
    if (value) {
      setCityID(value.value);
      setCityName(value.label);
    } else {
      setCityID("");
      setCityName("");
    }
  };

  /*** 
  @purpose : Handle BU change
  @Parameter : {value}
  **/
  const handleBUChange = async (value) => {
    setDivisionLoading(true);
    setDivisionID("");
    setDivisionName("");
    setBranchID("");
    setBranchName("");
    setSalesOfficeID("");
    setSalesOfficeName("");
    setMRID("");
    setMRName("");
    if (value) {
      setBuID(value.value);
      setBuName(value.label);
      await fetchDivisionList(value.value).then((res) => {
        setDivisionLoading(false);
        let list = [];
        for (let index = 0; index < res.length; index++) {
          const item = res[index];
          list.push({ value: item.divisionID, label: item.orgName });
        }
        setDivisionList(list);
      });
    } else {
      setDivisionLoading(false);
      setBuID("");
      setBuName("");
      setDivisionID("");
      setDivisionName("");
      setBranchID("");
      setBranchName("");
      setSalesOfficeID("");
      setSalesOfficeName("");
      setMRID("");
      setMRName("");
    }
  };

  /*** 
  @purpose : Handle division change
  @Parameter : {value}
  **/
  const handleDivisionChange = async (value) => {
    setBranchLoading(true);
    setBranchID("");
    setBranchName("");
    setSalesOfficeID("");
    setSalesOfficeName("");
    setMRID("");
    setMRName("");
    if (value) {
      setDivisionID(value.value);
      setDivisionName(value.label);
      await fetchBranchList({ buID: buID, divisionID: value.value }).then(
        (res) => {
          setBranchLoading(false);
          let list = [];
          for (let index = 0; index < res.length; index++) {
            const item = res[index];
            list.push({ value: item.branchID, label: item.orgName });
          }
          setBranchList(list);
        }
      );
    } else {
      setBranchLoading(false);
      setDivisionID("");
      setDivisionName("");
      setBranchID("");
      setBranchName("");
      setSalesOfficeID("");
      setSalesOfficeName("");
      setMRID("");
      setMRName("");
    }
  };

  /*** 
  @purpose : Handle branch change
  @Parameter : {}
  **/
  const handleBranchChange = async (value) => {
    setSalesOfficeLoading(true);
    setSalesOfficeID("");
    setSalesOfficeName("");
    setMRID("");
    setMRName("");
    if (value) {
      setBranchID(value.value);
      setBranchName(value.label);
      await fetchSalesOfficeList({
        buID: buID,
        divisionID: divisionID,
        branchID: value.value,
      }).then((res) => {
        setSalesOfficeLoading(false);
        let list = [];
        for (let index = 0; index < res.length; index++) {
          const item = res[index];
          list.push({ value: item.salesOfficeID, label: item.orgName });
        }
        setSalesOfficeList(list);
      });
    } else {
      setSalesOfficeLoading(false);
      setBranchID("");
      setBranchName("");
      setSalesOfficeID("");
      setSalesOfficeName("");
      setMRID("");
      setMRName("");
    }
  };

  /*** 
  @purpose : Handle sales office change
  @Parameter : {value}
  **/
  const handleSalesOfficeChange = async (value) => {
    setMRLoading(true);
    setMRID("");
    setMRName("");
    if (value) {
      setSalesOfficeID(value.value);
      setSalesOfficeName(value.label);
      let body = {
        buID: buID,
        divisionID: divisionID,
        branchID: branchID,
        salesOfficeID: value.value,
      };
      await fetchMRList(body).then((res) => {
        setMRLoading(false);
        let list = [];
        for (let index = 0; index < res.length; index++) {
          const item = res[index];
          list.push({ value: item.wwid, label: item.mrName });
        }
        setMRList(list);
      });
    } else {
      setMRLoading(false);
      setSalesOfficeID("");
      setSalesOfficeName("");
      setMRID("");
      setMRName("");
    }
  };

  /*** 
  @purpose : Handle MR change
  @Parameter : {value}
  **/
  const handleMRChange = async (value) => {
    if (value) {
      setMRID(value.value);
      setMRName(value.label);
    } else {
      setMRID("");
      setMRName("");
    }
  };

  /*** 
  @purpose : Handle modal state change
  @Parameter : {value}
  **/
  const handleModalStateChange = async (value) => {
    setModalCityID("");
    setModalCityName("");
    setModalCityLoading(true);
    if (value) {
      let id = value.value;
      setModalPrefectureID(id);
      setModalPrefectureName(value.label);
      await fetchCityList(id).then((res) => {
        setModalCityLoading(false);
        let newCity = [];
        for (let index = 0; index < res.length; index++) {
          const cityOne = res[index];
          newCity.push({ value: cityOne.cityID, label: cityOne.cityName });
        }
        setCityList(newCity);
      });
    } else {
      setModalCityLoading(false);
      setModalPrefectureID("");
      setModalPrefectureName("");
      setModalCityID("");
      setModalCityName("");
    }
  };

  /*** 
  @purpose : Handle modal city change
  @Parameter : {value}
  **/
  const handleModalCityChange = async (value) => {
    if (value) {
      setModalCityID(value.value);
      setModalCityName(value.label);
    } else {
      setModalCityID("");
      setModalCityName("");
    }
  };

  /*** 
  @purpose : Handle modal BU change
  @Parameter : {value}
  **/
  const handleModalBUChange = async (value) => {
    setModalDivisionLoading(true);
    setModalDivisionID("");
    setModalDivisionName("");
    setModalBranchID("");
    setModalBranchName("");
    setModalSalesOfficeID("");
    setModalSalesOfficeName("");
    setModalMRID("");
    setModalMRName("");
    if (value) {
      setModalDivisionLoading(false);
      setModalBuID(value.value);
      setModalBuName(value.label);
      await fetchDivisionList(value.value).then((res) => {
        let list = [];
        for (let index = 0; index < res.length; index++) {
          const item = res[index];
          list.push({ value: item.divisionID, label: item.orgName });
        }
        setDivisionList(list);
      });
    } else {
      setModalDivisionLoading(false);
      setModalBuID("");
      setModalBuName("");
      setModalDivisionID("");
      setModalDivisionName("");
      setModalBranchID("");
      setModalBranchName("");
      setModalSalesOfficeID("");
      setModalSalesOfficeName("");
      setModalMRID("");
      setModalMRName("");
    }
  };

  /*** 
  @purpose : Handle modal division change
  @Parameter : {value}
  **/
  const handleModalDivisionChange = async (value) => {
    setModalBranchLoading(true);
    setModalBranchID("");
    setModalBranchName("");
    setModalSalesOfficeID("");
    setModalSalesOfficeName("");
    setModalMRID("");
    setModalMRName("");
    if (value) {
      setModalDivisionID(value.value);
      setModalDivisionName(value.label);
      await fetchBranchList({ buID: modalBuID, divisionID: value.value }).then(
        (res) => {
          setModalBranchLoading(false);
          let list = [];
          for (let index = 0; index < res.length; index++) {
            const item = res[index];
            list.push({ value: item.branchID, label: item.orgName });
          }
          setBranchList(list);
        }
      );
    } else {
      setModalBranchLoading(false);
      setModalDivisionID("");
      setModalDivisionName("");
      setModalBranchID("");
      setModalBranchName("");
      setModalSalesOfficeID("");
      setModalSalesOfficeName("");
      setModalMRID("");
      setModalMRName("");
    }
  };

  /*** 
  @purpose : Handle modal branch change
  @Parameter : {}
  **/
  const handleModalBranchChange = async (value) => {
    setModalSalesOfficeLoading(true);
    setModalSalesOfficeID("");
    setModalSalesOfficeName("");
    setModalMRID("");
    setModalMRName("");
    if (value) {
      setModalBranchID(value.value);
      setModalBranchName(value.label);
      await fetchSalesOfficeList({
        buID: modalBuID,
        divisionID: modalDivisionID,
        branchID: value.value,
      }).then((res) => {
        setModalSalesOfficeLoading(false);
        let list = [];
        for (let index = 0; index < res.length; index++) {
          const item = res[index];
          list.push({ value: item.salesOfficeID, label: item.orgName });
        }
        setSalesOfficeList(list);
      });
    } else {
      validateForm(false);
      setModalBranchID("");
      setModalBranchName("");
      setModalSalesOfficeID("");
      setModalSalesOfficeName("");
      setModalMRID("");
      setModalMRName("");
    }
  };

  /*** 
  @purpose : Handle modal sales office change
  @Parameter : {value}
  **/
  const handleModalSalesOfficeChange = async (value) => {
    const loginWWID = sessionStorage.getItem("WWID");
    const userRole = sessionStorage.getItem("User role");
    setModalMRLoading(true);
    setModalMRID("");
    setModalMRName("");
    if (value) {
      setModalSalesOfficeID(value.value);
      setModalSalesOfficeName(value.label);
      let body = {
        buID: modalBuID,
        divisionID: modalDivisionID,
        branchID: modalBranchID,
        salesOfficeID: value.value,
        page: "parentChildFacilityMaintenance",
        wwid: loginWWID,
      };
      await fetchMRList(body).then((res) => {
        setModalMRLoading(false);
        let list = [];
        // if (userRole === "MR") {
        //   list = res.filter(mr => mr.wwid === loginWWID)
        //   for (let index = 0; index < list.length; index++) {
        //     const item = list[index];
        //     list.push({ value: item.wwid, label: item.mrName });
        //   }
        //   setModalMRList(list);
        // } else {
        if (res.length > 0) {
          for (let index = 0; index < res.length; index++) {
            const item = res[index];
            list.push({ value: item.wwid, label: item.mrName });
          }
          setModalMRList(list);
        }
        // }
      });
    } else {
      setModalMRLoading(false);
      setModalSalesOfficeID("");
      setModalSalesOfficeName("");
      setModalMRID("");
      setModalMRName("");
    }
  };

  /*** 
  @purpose : Handle modal MR change
  @Parameter : {value}
  **/
  const handleModalMRChange = async (value) => {
    if (value) {
      setModalMRID(value.value);
      setModalMRName(value.label);
    } else {
      setModalMRID("");
      setModalMRName("");
    }
  };

  /*** 
  @purpose : Validate facility search form
  @Parameter : {}
  **/
  const validateForm = () => {
    let isFormValid = true;
    let pattern = new RegExp(/[<(.|\n*?)>]/);
    // let regex = new RegExp(/[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|\u203B/g);
    let regex = new RegExp(
      /[一-龠]+|[ぁ-ゔ]+|[ァ-ヴー]+|[a-zA-Z0-9]+|[ａ-ｚＡ-Ｚ０-９]+[々〆〤]+/
    );
    let errors = {
      bu: "",
      division: "",
      branch: "",
      salesOffice: "",
      mr: "",
      facilityName: "",
    };

    // if (buID === "") errors.bu = "errorMessages.PROVIDE_BU";
    // if (divisionID === "") errors.division = "errorMessages.PROVIDE_DIVISION";
    // if (branchID === "") errors.branch = "errorMessages.PROVIDE_BRANCH";
    // if (salesOfficeID === "")
    //   errors.salesOffice = "errorMessages.PROVIDE_SALES_OFFICE";
    // if (mrID === "") errors.mr = "errorMessages.PROVIDE_MR";

    if (cusCode === "") errors.mr = "errorMessages.VALID_FACILITY_NAME";
    else errors.mr = "";
    if (facilityName === "")
      errors.facilityName = "errorMessages.VALID_FACILITY_NAME";
    else errors.facilityName = "";

    if (
      // errors.bu !== "" ||
      // errors.division !== "" ||
      // errors.branch !== "" ||
      // errors.salesOffice !== "" ||
      errors.mr !== "" &&
      errors.facilityName !== ""
    ) {
      isFormValid = false;
    } else {
      isFormValid = true;
    }
    setErrors(errors);
    return isFormValid;
  };

  /*** 
  @purpose : Handle sorting
  @Parameter : {}
  **/
  const handleSort = (col) => {
    let list = [...facilitySearchList];
    list.sort((a, b) => {
      if (`a.${col}` < `b.${col}`) {
        return -1;
      }
      if (`a.${col}` > `b.${col}`) {
        return 1;
      }
      return 0;
    });
    setFacilitySearchList(list);
  };

  /*** 
  @purpose : Handle sorting
  @Parameter : {}
  **/
  const handleModalSort = (col) => {
    let list = [...modalFacilitySearchList];
    list.sort((a, b) => {
      if (`a.${col}` < `b.${col}`) {
        return -1;
      }
      if (`a.${col}` > `b.${col}`) {
        return 1;
      }
      return 0;
    });
    setModalFacilitySearchList(list);
  };

  /*** 
  @purpose : Handle facility search
  @Parameter : {}
  **/
  const handleFacilitySearch = async () => {
    if (validateForm()) {
      setNoData(false);
      setFacilitySearchList([]);
      setParentFacilityList([]);
      setLoading(true);
      setFacilityTotal(0);
      let body = {
        mr_id: mrID,
        prefecture_id: prefectureID,
        city_id: cityID,
        facility_name: facilityName,
        customer_code: cusCode,
        limit: 0,
        total: 0,
      };
      setFacilityLazyLoadData(body);
      await getChildFacilityList(body).then((response) => {
        if (response.maintenanceWindowFlag) {
          setMaintenance(true);
        } else {
          if (response.success === true && response.data.length > 0) {
            setLoading(false);
            setFacilitySearchList(response.data);
            setNoData(false);
            setFacilityTotal(response && response.data[0].total);
          }
          if (
            (response.success === true && response.data.length === 0) ||
            response.success === false
          ) {
            setLoading(false);
            setNoData(true);
            setFacilitySearchList([]);
          }
        }
      });
    }
  };

  // const handleContainerOnBottom = async () => {
  //   setLazyLoading(true);
  //   let body = {
  //     mr_id: facilityLazyLoadData.mr_id,
  //     prefecture_id: facilityLazyLoadData.prefecture_id,
  //     city_id: facilityLazyLoadData.city_id,
  //     facility_name: facilityLazyLoadData.facility_name,
  //     limit: facilitySearchList.length,
  //     totalRecords: facilityTotal,
  //   };
  //   setLazyLoading(false);
  //   if (facilitySearchList.length <= facilityTotal && facilityTotal >= 30) {
  //     await getChildFacilityList(body).then((response) => {
  //       let list = [];
  //       list = facilitySearchList.concat(response.data);
  //       setFacilitySearchList(list);
  //     });
  //     setLimit(limit + 10);
  //   }
  // };

  const loadRecords = async () => {
    setLazyLoading(true);
    let body = {
      mr_id: facilityLazyLoadData.mr_id,
      prefecture_id: facilityLazyLoadData.prefecture_id,
      city_id: facilityLazyLoadData.city_id,
      facility_name: facilityLazyLoadData.facility_name,
      limit: facilitySearchList.length,
      totalRecords: facilityTotal,
    };
    setLazyLoading(false);
    if (facilitySearchList.length < facilityTotal) {
      await getChildFacilityList(body).then((response) => {
        let list = [];
        list = facilitySearchList.concat(response.data);
        setFacilitySearchList(list);
      });
      setLimit(limit + 10);
    }
  };

  // const containerRef = useBottomScrollListener(handleContainerOnBottom);

  /*** 
  @purpose : Validate facility search form
  @Parameter : {}
  **/
  const validateModalForm = () => {
    let isFormValid = true;
    let pattern = new RegExp(/[<(.|\n*?)>]/);
    // let regex = new RegExp(/[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|\u203B/g);
    let regex = new RegExp(
      /[一-龠]+|[ぁ-ゔ]+|[ァ-ヴー]+|[a-zA-Z0-9]+|[ａ-ｚＡ-Ｚ０-９]+[々〆〤]+/
    );
    let errors = {
      bu: "",
      division: "",
      branch: "",
      salesOffice: "",
      mr: "",
      facilityName: "",
    };

    if (modalBuID === "") errors.bu = "errorMessages.PROVIDE_BU";
    if (modalDivisionID === "")
      errors.division = "errorMessages.PROVIDE_DIVISION";
    if (modalBranchID === "") errors.branch = "errorMessages.PROVIDE_BRANCH";
    if (modalSalesOfficeID === "")
      errors.salesOffice = "errorMessages.PROVIDE_SALES_OFFICE";
    if (modalMrID === "") errors.mr = "errorMessages.PROVIDE_MR";

    if (
      modalFacilityName &&
      pattern.test(modalFacilityName) &&
      modalCustomerCode &&
      pattern.test(modalCustomerCode)
    )
      errors.facilityName = "errorMessages.VALID_FACILITY_NAME";
    else if (modalFacilityName === "" && modalCustomerCode === "")
      errors.facilityName = "errorMessages.VALID_FACILITY_NAME";
    else errors.facilityName = "";

    if (
      errors.bu !== "" ||
      errors.division !== "" ||
      errors.branch !== "" ||
      errors.salesOffice !== "" ||
      errors.mr !== "" ||
      errors.mr !== "" ||
      errors.facilityName !== ""
    ) {
      isFormValid = false;
    } else {
      isFormValid = true;
    }
    setModalErrors(errors);
    return isFormValid;
  };

  /*** 
  @purpose : Handle modal facility search
  @Parameter : {}
  **/
  const handleModalFacilitySearch = async () => {
    if (validateModalForm()) {
      setModalLoading(true);
      setModalFacilitySearchList([]);
      setNoModalData(false);
      setModalFacilityTotal(0);
      let body = {
        mr_id: modalMrID,
        prefecture_id: modalPrefectureID,
        city_id: modalCityID,
        facility_name: modalFacilityName,
        customer_code: modalCustomerCode,
        limit: 0,
        total: 0,
      };
      setModalFacilityLazyLoadData(body);
      await getConfigurableParentFacilityList(body).then((response) => {
        if (response.maintenanceWindowFlag) {
          setMaintenance(true);
        } else {
          if (response.success === true && response.data.length > 0) {
            setModalLoading(false);
            setModalFacilitySearchList(response.data);
            setNoModalData(false);
            setModalFacilityTotal(response && response.data[0].total);
          }
          if (
            (response.success === true && response.data.length === 0) ||
            response.success === false
          ) {
            setModalLoading(false);
            setNoModalData(true);
            setModalFacilitySearchList([]);
            setModalFacilityTotal(0);
          }
        }
      });
    }
  };

  const handleModalFacilityContainerOnBottom = async () => {
    setModalLazyLoading(true);
    let body = {
      mr_id: modalFacilityLazyLoadData.mr_id,
      prefecture_id: modalFacilityLazyLoadData.prefecture_id,
      city_id: modalFacilityLazyLoadData.city_id,
      facility_name: modalFacilityLazyLoadData.facility_name,
      limit: modalFacilitySearchList.length,
      totalRecords: modalFacilityTotal,
    };
    setModalLazyLoading(false);
    if (modalFacilitySearchList.length < modalFacilityTotal) {
      await getConfigurableParentFacilityList(body).then((response) => {
        let list = [];
        list = modalFacilitySearchList.concat(response.data);
        setModalFacilitySearchList(list);
      });
      setModalLimit(modalLimit + 10);
    }
  };

  const loadModalRecords = async () => {
    setModalLazyLoading(true);
    let body = {
      mr_id: modalFacilityLazyLoadData.mr_id,
      prefecture_id: modalFacilityLazyLoadData.prefecture_id,
      city_id: modalFacilityLazyLoadData.city_id,
      facility_name: modalFacilityLazyLoadData.facility_name,
      limit: modalFacilitySearchList.length,
      totalRecords: modalFacilityTotal,
    };
    setModalLazyLoading(false);
    if (modalFacilitySearchList.length < modalFacilityTotal) {
      await getConfigurableParentFacilityList(body).then((response) => {
        let list = [];
        list = modalFacilitySearchList.concat(response.data);
        setModalFacilitySearchList(list);
      });
      setModalLimit(modalLimit + 10);
    }
  };

  // const modalContainerRef = useBottomScrollListener(
  //   handleModalFacilityContainerOnBottom
  // );

  /*** 
  @purpose : Show facility details
  @Parameter : {value}
  **/
  const showFacilityDetails = async (fac) => {
    setParentFacilityLoading(true);
    setParentFacilityList([]);
    setEventKey(eventKey == "0" ? "1" : "0");
    setShowOrgId(fac.orgCustID);
    setShowOrgCode(fac.customerCode);
    setShowOrgName(fac.facilityName);
    let body = {
      organization_customer_id: fac.orgCustID,
    };
    await getParentFacilityList(body).then((response) => {
      if (response.maintenanceWindowFlag) {
        setMaintenance(true);
      } else {
        if (response.success === true && response.data.length === 0) {
          setParentFacilityLoading(false);
          setNoParentFacilityData(true);
          setParentFacilityList([]);
        }
        if (response.success === true && response.data.length > 0) {
          setParentFacilityLoading(false);
          setParentFacilityList(response.data);
          setShowFacilityData("card");
          setNoParentFacilityData(false);
        }
      }
    });
  };

  const removeFacility = (fac) => {
    let obj = {
      id: fac.ID,
      status: "clear",
      childID: showOrgId,
      parent_id: fac.parentID,
    };
    let list = [...modifiedFacilityList, obj];
    setModifiedFacilityList(list);
    let tempList = parentFacilityList;
    tempList.map((facility) => {
      if (facility.ID === fac.ID) {
        // facility.parentID = "";
        fac.legacyUnifiedCustomerCode = "";
        fac.unifiedCustomerCode =
          ""; /* SAKAMOTO: AHDD-5861 Ultmarc code change */
        facility.customerNameLocalAbbr = "";
      }
    });
    setParentFacilityList(tempList);
  };

  const updateFacility = (fac) => {
    let obj = {
      MarketAuthID: updatedFacility.MarketAuthID,
      childID: showOrgId,
      orgCustID: fac.orgCustID,
    };
    // let list = [...modifiedFacilityList, obj];

    let tempModifiedList = modifiedFacilityList;
    if (modifiedFacilityList.length > 0) {
      let list = [];
      tempModifiedList.map((item) => {
        list.push(item.MarketAuthID);
      });
      if (list.includes(updatedFacility.MarketAuthID)) {
        tempModifiedList.map((item) => {
          if (item.marketAuthID === updatedFacility.MarketAuthID) {
            item.orgCustID = fac.orgCustID;
            setModifiedFacilityList(tempModifiedList);
          }
        });
      } else {
        tempModifiedList.push(obj);
        setModifiedFacilityList(tempModifiedList);
      }
      // tempModifiedList.map(item => {
      //   if (list.includes(updatedFacility.MarketAuthID)) {
      //     item.orgCustID = fac.orgCustID
      //     setModifiedFacilityList(tempModifiedList)
      //   } else {
      //     tempModifiedList.push(obj)
      //     setModifiedFacilityList(tempModifiedList)
      //   }
      // })
    } else {
      let data = [...modifiedFacilityList, obj];
      setModifiedFacilityList(data);
    }

    // setModifiedFacilityList(tempModifiedList)

    // setModifiedFacilityList(list);
    setShow(false);
    let tempList = parentFacilityList;
    tempList.map((facility) => {
      if (facility.ID === updatedFacility.ID) {
        // facility.parentID = fac.orgCustID;
        /* facility.legacyUnifiedCustomerCode = fac.customerCode;    /* SAKAMOTO: AHDD-5861 Ultmarc code change */
        facility.unifiedCustomerCode =
          fac.customerCode; /* SAKAMOTO: AHDD-5861 Ultmarc code change */
        facility.customerNameLocalAbbr = fac.facilityName;
      }
    });
    setParentFacilityList(tempList);
  };
  const handleSuccessClose = () => {
    setSuccessShow(false);
    setModalFacilityName("");
    setModalFacilitySearchList([]);
    setModalBuID("");
    setModalBuName("");
    setModalDivisionID("");
    setModalDivisionName("");
    setModalBranchID("");
    setModalBranchName("");
    setModalSalesOfficeID("");
    setModalSalesOfficeName("");
    setModalMRID("");
    setModalMRName("");
  };

  const modalSuccessShow = () => setSuccessShow(true);

  const handleShowError = () => setShowError(false);

  const modalShowError = () => setShowError(true);

  const handleParentChildFacilityChange = async () => {
    setResultLoading(true);
    let body = {
      data: modifiedFacilityList,
    };
    await saveParentChildFacilityChange(body).then((response) => {
      setResultLoading(false);
      if (response.success === true && response.error === 0) {
        modalSuccessShow();
      } else if (response.success === false && response.error === 1) {
        modalShowError();
      }
      setModifiedFacilityList([]);
    });
  };

  const [text, setText] = useState({});
  const [language, setLang] = useState({});

  useEffect(() => {
    if (sessionStorage.getItem("translation")) {
      setText(JSON.parse(sessionStorage.getItem("translation")));
    }
    if (sessionStorage.getItem("translation")) {
      setLang(sessionStorage.getItem("Language"));
    }
  }, [sessionStorage.getItem("Language")]);

  const [finalText, setfinalText] = useState("");
  const [finalText2, setfinalText2] = useState("");
  useEffect(() => {
    const searchText = "parentchild";
    const searchText2 = "commonmessage";
    const filteredTexts = {};
    const filteredTexts2 = {};
    for (const key in text) {
      if (key.includes(searchText)) {
        if (key.endsWith('_en') || key.endsWith('_ja')) {
          const langKey = key.includes("_en") ? "en" : "jp";
          const value = text[key];
          filteredTexts[langKey] = value;
        }
      }
    }
    for (const key in text) {
      if (key.includes(searchText2)) {
        if (key.endsWith('_en') || key.endsWith('_ja')) {
          const langKey = key.includes("_en") ? "en" : "jp";
          const value = text[key];
          filteredTexts2[langKey] = value;
        }
      }
    }
    if (filteredTexts[language]) {
      setfinalText(filteredTexts[language]);
    }
    if (filteredTexts2[language]) {
      setfinalText2(filteredTexts2[language]);
    }

  }, [language, text]);

  return role === "Admin" ||
    role === "SalesManager" ||
    role === "MR" ||
    role === "BusinessOperation" ? (
    <Home>
      {maintenance ? (
        <Maintenance />
      ) : (
        <>
          <Breadcrumb
            finalText2={finalText2}
            finalText={finalText}
            routes={routes}
          />
          <h2>{lang("Menu.parentChildFacility")}</h2>

          <Accordion defaultActiveKey="0">
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                {lang("parentChildFacilityMaintenance.facilitySearch")}
              </Accordion.Header>
              <Accordion.Body>
                <div className="row">
                    {/* <div className="col-xl-3 col-md-4 col-sm-6">
                      <div className="form-group">
                        <label>
                          {lang("territoryDefinitionMaintenance.BU")}
                          <span className="danger">*</span>{" "}
                        </label>
                        <Select
                          className="ant-select"
                          options={buList}
                          onChange={handleBUChange}
                          placeholder="(BU)"
                          isClearable={buID ? true : false}
                          value={{ value: buID, label: buName }}
                          isSearchable={
                            buList && buList.length > 0 ? true : false
                          }
                        />
                        {errors.bu && (
                          <p className="error-text">{lang(`${errors.bu}`)}</p>
                        )}
                      </div>
                    </div> */}
                    {/* <div className="col-xl-3 col-md-4 col-sm-6">
                      <div className="form-group">
                        <label>
                          {lang("territoryDefinitionMaintenance.division")}
                          <span className="danger">*</span>{" "}
                        </label>
                        <Select
                          className="ant-select"
                          options={divisionList}
                          value={{ value: divisionID, label: divisionName }}
                          onChange={handleDivisionChange}
                          placeholder="(Division)"
                          isLoading={divisionLoading}
                          isDisabled={buID ? false : true}
                          isClearable={divisionID ? true : false}
                          isSearchable={
                            divisionList && divisionList.length > 0
                              ? true
                              : false
                          }
                        />
                        {errors.division && (
                          <p className="error-text">
                            {lang(`${errors.division}`)}
                          </p>
                        )}
                      </div>
                    </div> */}
                    {/* <div className="col-xl-3 col-md-4 col-sm-6">
                      <div className="form-group">
                        <label>
                          {lang("territoryDefinitionMaintenance.branch")}
                          <span className="danger">*</span>{" "}
                        </label>
                        <Select
                          className="ant-select"
                          options={branchList}
                          value={{ value: branchID, label: branchName }}
                          onChange={handleBranchChange}
                          placeholder="(Branch)"
                          isLoading={branchLoading}
                          isDisabled={divisionID ? false : true}
                          isClearable={branchID ? true : false}
                          isSearchable={
                            branchList && branchList.length > 0 ? true : false
                          }
                        />
                        {errors.branch && (
                          <p className="error-text">
                            {lang(`${errors.branch}`)}
                          </p>
                        )}
                      </div>
                    </div> */}
                    {/* <div className="col-xl-3 col-md-4 col-sm-6">
                      <div className="form-group">
                        <label>
                          {lang("territoryDefinitionMaintenance.salesOffice")}
                          <span className="danger">*</span>{" "}
                        </label>
                        <Select
                          className="ant-select"
                          options={salesOfficeList}
                          value={{
                            value: salesOfficeID,
                            label: salesOfficeName,
                          }}
                          isDisabled={branchID ? false : true}
                          onChange={handleSalesOfficeChange}
                          isLoading={salesOfficeLoading}
                          placeholder="(Sales Office)"
                          isClearable={salesOfficeID ? true : false}
                          isSearchable={
                            salesOfficeList && salesOfficeList.length > 0
                              ? true
                              : false
                          }
                        />
                        {errors.salesOffice && (
                          <p className="error-text">
                            {lang(`${errors.salesOffice}`)}
                          </p>
                        )}
                      </div>
                    </div> */}
                    {/* <div className="col-xl-3 col-md-4 col-sm-6">
                      <div className="form-group">
                        <label>
                          {lang("parentChildFacilityMaintenance.mr")}
                          <span className="danger">*</span>{" "}
                        </label>
                        <Select
                          className="ant-select"
                          options={mrList}
                          value={{ value: mrID, label: mrName }}
                          isDisabled={salesOfficeID ? false : true}
                          onChange={handleMRChange}
                          isLoading={mrLoading}
                          placeholder="(MR)"
                          isClearable={mrID ? true : false}
                          isSearchable={
                            mrList && mrList.length > 0 ? true : false
                          }
                        />
                        {errors.mr && (
                          <p className="error-text">{lang(`${errors.mr}`)}</p>
                        )}
                      </div>
                    </div> */}
                    <div className="col-xl-3 col-md-4 col-sm-6">
                      <div className="form-group">
                        <label>
                          {lang("parentChildFacilityMaintenance.prefecture")}
                        </label>
                        <Select
                          className="ant-select"
                          options={prefectureList}
                          onChange={handleStateChange}
                          value={prefectureID ? { value: prefectureID, label: prefectureName } : undefined}
                          allowClear={prefectureID ? true : false}
                          showSearch={
                            prefectureList && prefectureList.length > 0
                              ? true
                              : false
                          }
                          labelInValue={true}
                          optionFilterProp="label"
                        />
                      </div>
                    </div>
                    <div className="col-xl-3 col-md-4 col-sm-6">
                      <div className="form-group">
                        <label>
                          {lang("parentChildFacilityMaintenance.city")}
                        </label>
                        <Select
                          className="ant-select"
                          options={cityList}
                          onChange={handleCityChange}
                          loading={cityLoading}
                          value={cityID ? { value: cityID, label: cityName } : undefined}
                          disabled={prefectureID ? false : true}
                          allowClear={cityID ? true : false}
                          showSearch={
                            cityList && cityList.length > 0 ? true : false
                          }
                          labelInValue={true}
                          optionFilterProp="label"
                        />
                      </div>
                    </div>
                    <div className="col-xl-3 col-md-4 col-sm-6">
                      <div className="form-group">
                        <label>{lang("OrganizationMenu.facilityName")}</label>
                        <input
                          type="text"
                          className="form-control"
                          value={facilityName}
                          onChange={(e) => setFacilityName(e.target.value)}
                        />
                        {(errors.facilityName && errors.mr) && (
                          <p className="error-text">
                            {lang(`${errors.facilityName}`)}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="col-xl-3 col-md-4 col-sm-6">
                      <div className="form-group">
                        <label>{lang("OrganizationMenu.cutomerCode")}</label>
                        <input
                          type="text"
                          className="form-control"
                          value={cusCode}
                          onChange={(e) => setCusCode(e.target.value)}
                        />
                        {/* {errors.facilityName && (
                          <p className="error-text">
                            {lang(`${errors.facilityName}`)}
                          </p>
                        )} */}
                      </div>
                    </div>
                    <div className="steps-action1 col-12">
                      {loading && <Spinner animation="border" />}
                      <button
                        className="btn btn-primary"
                        onClick={handleFacilitySearch}
                        disabled={loading}
                      >
                        {lang("Buttons.apply")}
                      </button>
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

          {facilitySearchList && facilitySearchList.length > 0 && (
            <Accordion defaultActiveKey={eventKey}>
              <Accordion.Item eventKey={eventKey}>
                <Accordion.Header>
                  {lang("parentChildFacilityMaintenance.facilitySearch")}
                </Accordion.Header>
              <Accordion.Body>
                    {facilitySearchList &&
                      facilitySearchList.length > 0 &&
                      loading === false && (
                        <div className="mt-5">
                          <p className="record-total">
                            {lang(
                              "territoryDefinitionMaintenance.totalRecords"
                            )}{" "}
                            - {facilitySearchList.length} / {facilityTotal}
                          </p>
                          <div
                            // ref={containerRef}
                            // onBottom={handleContainerOnBottom}
                            className="table-responsive mb-0 max-height"
                          >
                            <table className="table" aria-describedby="table">
                              <thead>
                                <tr>
                                  <th scope="col"></th>
                                  <th
                                    scope="col"
                                    onClick={() => handleSort("customerCode")}
                                  >
                                    <div className="cursor-pointer">
                                      {lang(
                                        "parentChildFacilityMaintenance.code"
                                      )}
                                      <em className="bx bxs-sort-alt"></em>
                                    </div>
                                  </th>
                                  <th
                                    scope="col"
                                    onClick={() => handleSort("facilityName")}
                                  >
                                    <div className="cursor-pointer">
                                      {lang(
                                        "parentChildFacilityMaintenance.name"
                                      )}{" "}
                                      <em className="bx bxs-sort-alt"></em>
                                    </div>
                                  </th>
                                  <th
                                    scope="col"
                                    onClick={() => handleSort("state_name")}
                                  >
                                    <div className="cursor-pointer">
                                      {lang(
                                        "parentChildFacilityMaintenance.prefecture"
                                      )}{" "}
                                      <em className="bx bxs-sort-alt"></em>
                                    </div>
                                  </th>
                                  <th
                                    scope="col"
                                    onClick={() => handleSort("city_name")}
                                  >
                                    <div className="cursor-pointer">
                                      {lang(
                                        "parentChildFacilityMaintenance.city"
                                      )}{" "}
                                      <em className="bx bxs-sort-alt"></em>
                                    </div>
                                  </th>
                                  <th
                                    scope="col"
                                    onClick={() =>
                                      handleSort("customer_type_name")
                                    }
                                  >
                                    <div className="cursor-pointer">
                                      {lang(
                                        "parentChildFacilityMaintenance.type"
                                      )}{" "}
                                      <em className="bx bxs-sort-alt"></em>
                                    </div>
                                  </th>
                                  <th
                                    scope="col"
                                    onClick={() => handleSort("number_of_beds")}
                                  >
                                    <div className="cursor-pointer">
                                      {lang(
                                        "parentChildFacilityMaintenance.noOfBeds"
                                      )}
                                      <em className="bx bxs-sort-alt"></em>
                                    </div>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {facilitySearchList &&
                                  facilitySearchList.length > 0 &&
                                  facilitySearchList.map((fac, key) => {
                                    return (
                                      <tr key={key}>
                                        <td>
                                          <button
                                            className="btn btn-primary"
                                            onClick={() =>
                                              showFacilityDetails(fac)
                                            }
                                          >
                                            {lang("Buttons.select")}
                                          </button>
                                        </td>
                                        <td>{fac && fac.customerCode}</td>
                                        <td>{fac && fac.facilityName}</td>
                                        <td>{fac && fac.state_name_local}</td>
                                        <td>{fac && fac.city_name_local}</td>
                                        <td>{fac && fac.customer_type_name}</td>
                                        <td>{fac && fac.number_of_beds}</td>
                                      </tr>
                                    );
                                  })}
                              </tbody>
                            </table>
                          </div>
                          {facilitySearchList.length < facilityTotal && (
                              <div className="steps-action1 mt-4">
                                {lazyLoading && <Spinner animation="border" />}
                                <button
                                  className="btn btn-primary"
                                  onClick={loadRecords}
                                  disabled={lazyLoading}
                                >
                                  {lang("Buttons.loadMore")}
                                </button>
                              </div>
                            )}
                        </div>
                      )}
              </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          )}
          {loading === true && <Spinner animation="border" />}
          {noData && <div className="noData">No data found</div>}
          {parentFacilityList && parentFacilityList.length > 0 && (
            <div className={showFacilityData}>
              <div className="card-header transperent">
                <h2>
                  {showOrgCode} : {showOrgName}
                </h2>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table" aria-describedby="table">
                    <thead>
                      <tr>
                        <th scope="col">
                          <div className="cursor-pointer">
                            {lang("parentChildFacilityMaintenance.product")}
                            <em className="bx bxs-sort-alt"></em>
                          </div>
                        </th>
                        <th scope="col">
                          <div className="cursor-pointer">
                            {lang(
                              "parentChildFacilityMaintenance.parentFacility"
                            )}
                            <em className="bx bxs-sort-alt"></em>
                          </div>
                        </th>
                        <th scope="col">
                          <div className="cursor-pointer">
                            {lang("parentChildChangeRequest.status")}{" "}
                            <em className="bx bxs-sort-alt"></em>
                          </div>
                        </th>
                        <th scope="col">
                          <div className="cursor-pointer">
                            {lang("parentChildFacilityMaintenance.updatedBy")}
                            <em className="bx bxs-sort-alt"></em>
                          </div>
                        </th>
                        <th scope="col">
                          <div className="cursor-pointer">
                            {lang("parentChildFacilityMaintenance.approvedBy")}
                            <em className="bx bxs-sort-alt"></em>
                          </div>
                        </th>
                        <th scope="col">
                          <div className="cursor-pointer">
                            {lang("parentChildFacilityMaintenance.approvedOn")}
                            <em className="bx bxs-sort-alt"></em>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {parentFacilityList &&
                        parentFacilityList.map((fac,index) => {
                          return (
                            <tr key={index}>
                              <td>{fac.marketAuthourizationNameAbbr}</td>
                              <td>
                                <div className="mrs-box mb-0">
                                  <label className={facilityLabel}>
                                    {/* fac.legacyUnifiedCustomerCode &&           /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                    /* fac.legacyUnifiedCustomerCode + ":"}{" "}  /* SAKAMOTO: AHDD-5861 Ultmarc code change */}
                                    {fac.unifiedCustomerCode /* SAKAMOTO: AHDD-5861 Ultmarc code change */ &&
                                      fac.unifiedCustomerCode + ":"}
                                    {
                                      " " /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                    }
                                    {fac.customerNameLocalAbbr}
                                  </label>

                                  <div className="mrs-buttons">
                                    <button
                                      className="btn btn-primary"
                                      onClick={() => modalShow(fac)}
                                      disabled={
                                        fac.workflowState === "under_review" ||
                                        marketListing.includes(
                                          fac.MarketAuthID
                                        ) === false
                                      }
                                    >
                                      {lang("Buttons.select")}
                                    </button>
                                    <button
                                      className="btn btn-secondary"
                                      onClick={() => removeFacility(fac)}
                                      disabled={
                                        /* fac.legacyUnifiedCustomerCode === "" ||  /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                        /* fac.legacyUnifiedCustomerCode ===        /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                        fac.unifiedCustomerCode ===
                                          "" /* SAKAMOTO: AHDD-5861 Ultmarc code change */ ||
                                        fac.unifiedCustomerCode /* SAKAMOTO: AHDD-5861 Ultmarc code change */ ===
                                          null ||
                                        fac.workflowState === "under_review" ||
                                        marketListing.includes(
                                          fac.MarketAuthID
                                        ) === false
                                      }
                                    >
                                      {lang("Buttons.remove")}
                                    </button>
                                  </div>
                                </div>
                              </td>
                              <td>
                                {fac.workflowState === "under_review" && (
                                  <label className="status-label secondary-label">
                                    Under Review
                                  </label>
                                )}
                                {fac.workflowState === "approval_accepted" && (
                                  <label className="status-label primary-label">
                                    Published
                                  </label>
                                )}
                                {fac.workflowState === "approval_rejected" &&
                                  // <label className="status-label danger-label">
                                  //   Rejected
                                  // </label>
                                  ""}
                                {fac.workflowState === "" && ""}
                              </td>
                              <td>
                                <div>
                                  <span style={{ display: "block" }}>
                                    {fac.submittedByWwid}
                                  </span>
                                  <span>
                                    {fac.submittedBy}
                                  </span>
                                </div>
                              </td>
                              <td>
                                <div>
                                  <span style={{ display: "block" }}>
                                    {fac.reviewedByWwid}
                                  </span>
                                  <span>{fac.reviewedBy}</span>
                                </div>
                              </td>
                              <td>{fac.reviewedAt}</td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
                <div className="steps-action1 col-12">
                  {resultLoading && <Spinner animation="border" />}
                  <button
                    className="btn btn-primary"
                    onClick={handleParentChildFacilityChange}
                    disabled={resultLoading}
                  >
                    {lang("Buttons.submit")}
                  </button>
                </div>
              </div>
            </div>
          )}
          {noParentFacilityData && <div className="noData">No data found</div>}
          {parentFacilityLoading && <Spinner animation="border" />}
          <Modal
            width={MODAL_WIDTH.SMALL}
            className="withdraw-modal"
            open={successShow}
            onCancel={handleSuccessClose}
            centered
            footer={null}
          >
            <div className="warning-msg">
              {lang("errorMessages.PARENT_CHILD_RELATION")}
            </div>
            <div className="buttons-group">
              <button
                className="btn btn-primary"
                onClick={handleSuccessClose}
              >
                {lang("Buttons.ok")}
              </button>
            </div>
          </Modal>
          <Modal
            width={MODAL_WIDTH.SMALL}
            className="withdraw-modal"
            open={showError}
            onCancel={handleShowError}
            centered
            footer={null}
          >
            <div className="warning-msg">
              <img src="images/warning2.svg" alt="Warning" />{" "}
              {lang("errorMessages.DUPLICATE_RECORD")}
            </div>
            <div className="buttons-group">
              <button className="btn btn-primary" onClick={handleShowError}>
                {lang("Buttons.ok")}
              </button>
            </div>
          </Modal>
          <Modal
            width={MODAL_WIDTH.LARGE}
            open={show}
            onCancel={handleClose}
            centered
            footer={null}
            title={lang("parentChildFacilityMaintenance.facilitySearch")}
          >
              <div className="row">
                <div className="col-xl-3 col-md-6">
                  <div className="form-group">
                    <label>
                      {lang("territoryDefinitionMaintenance.BU")}
                      <span className="danger">*</span>
                    </label>
                    <Select
                      className="ant-select"
                      options={buList}
                      onChange={handleModalBUChange}
                      value={modalBuID ? { value: modalBuID, label: modalBuName } : undefined}
                      allowClear={modalBuID ? true : false}
                      showSearch={buList && buList.length > 0 ? true : false}
                      labelInValue={true}
                      optionFilterProp="label"
                      getPopupContainer={(trigger) => trigger.parentElement}
                    />
                    {modalErrors.bu && (
                      <p className="error-text">{lang(`${modalErrors.bu}`)}</p>
                    )}
                  </div>
                </div>
                <div className="col-xl-3 col-md-6">
                  <div className="form-group">
                    <label>
                      {lang("territoryDefinitionMaintenance.division")}
                      <span className="danger">*</span>
                    </label>
                    <Select
                      className="ant-select"
                      options={divisionList}
                      loading={modalDivisionLoading}
                      onChange={handleModalDivisionChange}
                      value={modalDivisionID ? {
                        value: modalDivisionID,
                        label: modalDivisionName,
                      } : undefined}
                      showSearch={
                        divisionList && divisionList.length > 0 ? true : false
                      }
                      allowClear={modalDivisionID ? true : false}
                      labelInValue={true}
                      optionFilterProp="label"
                      getPopupContainer={(trigger) => trigger.parentElement}
                    />
                    {modalErrors.division && (
                      <p className="error-text">
                        {lang(`${modalErrors.division}`)}
                      </p>
                    )}
                  </div>
                </div>
                <div className="col-xl-3 col-md-6">
                  <div className="form-group">
                    <label>
                      {lang("territoryDefinitionMaintenance.branch")}
                      <span className="danger">*</span>
                    </label>
                    <Select
                      className="ant-select"
                      options={branchList}
                      loading={modalBranchLoading}
                      value={modalBranchID ? { value: modalBranchID, label: modalBranchName } : undefined}
                      onChange={handleModalBranchChange}
                      showSearch={
                        branchList && branchList.length > 0 ? true : false
                      }
                      allowClear={modalBranchID ? true : false}
                      labelInValue={true}
                      optionFilterProp="label"
                      getPopupContainer={(trigger) => trigger.parentElement}
                    />
                    {modalErrors.branch && (
                      <p className="error-text">
                        {lang(`${modalErrors.branch}`)}
                      </p>
                    )}
                  </div>
                </div>
                <div className="col-xl-3 col-md-6">
                  <div className="form-group">
                    <label>
                      {lang("territoryDefinitionMaintenance.salesOffice")}
                      <span className="danger">*</span>
                    </label>
                    <Select
                      className="ant-select"
                      options={salesOfficeList}
                      loading={modalSalesOfficeLoading}
                      value={modalSalesOfficeID ? {
                        value: modalSalesOfficeID,
                        label: modalSalesOfficeName,
                      } : undefined}
                      onChange={handleModalSalesOfficeChange}
                      showSearch={
                        salesOfficeList && salesOfficeList.length > 0
                          ? true
                          : false
                      }
                      allowClear={modalSalesOfficeID ? true : false}
                      labelInValue={true}
                      optionFilterProp="label"
                      getPopupContainer={(trigger) => trigger.parentElement}
                    />
                    {modalErrors.salesOffice && (
                      <p className="error-text">
                        {lang(`${modalErrors.salesOffice}`)}
                      </p>
                    )}
                  </div>
                </div>
                <div className="col-xl-3 col-md-6">
                  <div className="form-group">
                    <label>
                      {lang("parentChildFacilityMaintenance.mr")}
                      <span className="danger">*</span>
                    </label>
                    <Select
                      className="ant-select"
                      options={modalMRList}
                      onChange={handleModalMRChange}
                      value={modalMrID ? { value: modalMrID, label: modalMrName } : undefined}
                      showSearch={mrList && mrList.length > 0 ? true : false}
                      loading={modalMRLoading}
                      allowClear={modalMrID ? true : false}
                      labelInValue={true}
                      optionFilterProp="label"
                      getPopupContainer={(trigger) => trigger.parentElement}
                    />
                    {modalErrors.mr && (
                      <p className="error-text">{lang(`${modalErrors.mr}`)}</p>
                    )}
                  </div>
                </div>
                <div className="col-xl-3 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>
                      {lang("parentChildFacilityMaintenance.prefecture")}
                    </label>
                    <Select
                      className="ant-select"
                      options={prefectureList}
                      onChange={handleModalStateChange}
                      value={modalPrefectureID ? {
                        value: modalPrefectureID,
                        label: modalPrefectureName,
                      } : undefined}
                      showSearch={
                        prefectureList && prefectureList.length > 0
                          ? true
                          : false
                      }
                      allowClear={modalPrefectureID ? true : false}
                      labelInValue={true}
                      optionFilterProp="label"
                      getPopupContainer={(trigger) => trigger.parentElement}
                    />
                  </div>
                </div>
                <div className="col-xl-3 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>{lang("parentChildFacilityMaintenance.city")}</label>
                    <Select
                      className="ant-select"
                      options={cityList}
                      onChange={handleModalCityChange}
                      disabled={modalPrefectureID ? false : true}
                      loading={modalCityLoading}
                      value={modalCityID ? { value: modalCityID, label: modalCityName } : undefined}
                      showSearch={
                        cityList && cityList.length > 0 ? true : false
                      }
                      allowClear={modalCityID ? true : false}
                      labelInValue={true}
                      optionFilterProp="label"
                      getPopupContainer={(trigger) => trigger.parentElement}
                    />
                  </div>
                </div>

                <div className="clearfix"></div>
                <div className="col-xl-3 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>
                      {lang("OrganizationMenu.facilityName")}
                      {/* <span className="danger">*</span> */}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={modalFacilityName}
                      onChange={(e) => setModalFacilityName(e.target.value)}
                    />
                    {modalErrors.facilityName && (
                      <p className="error-text">
                        {lang(`${modalErrors.facilityName}`)}
                      </p>
                    )}
                  </div>
                </div>
                <div className="col-xl-3 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label style={{ width: "290px" }}>
                      {lang("OrganizationMenu.cutomerCode")}
                      {/* <span className="danger">*</span> */}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={modalCustomerCode}
                      onChange={(e) => setModalCustomerCode(e.target.value)}
                    />
                    {/* {modalErrors.facilityName && (
                      <p className="error-text">
                        {lang(`${modalErrors.facilityName}`)}
                      </p>
                    )} */}
                  </div>
                </div>
                <div className="steps-action1 col-12 mb-4">
                  {modalLoading && <Spinner animation="border" />}
                  <button
                    className="btn btn-primary"
                    onClick={handleModalFacilitySearch}
                    disabled={modalLoading}
                  >
                    {lang("Buttons.apply")}
                  </button>
                </div>
              </div>
              {modalFacilitySearchList &&
                modalFacilitySearchList.length > 0 && (
                  <>
                    <p className="record-total">
                      {lang("territoryDefinitionMaintenance.totalRecords")} -{" "}
                      {modalFacilitySearchList.length} / {modalFacilityTotal}
                    </p>
                    <div
                      // ref={modalContainerRef}
                      // onBottom={handleModalFacilityContainerOnBottom}
                      className="table-responsive max-height-md"
                    >
                      <table className="table" aria-describedby="table">
                        <thead>
                          <tr>
                            <th scope="col"></th>
                            <th
                              scope="col"
                              onClick={() => handleModalSort("customerCode")}
                            >
                              <div className="cursor-pointer">
                                {lang("parentChildFacilityMaintenance.code")}
                                <em className="bx bxs-sort-alt"></em>
                              </div>
                            </th>
                            <th
                              scope="col"
                              onClick={() => handleModalSort("facilityName")}
                            >
                              <div className="cursor-pointer">
                                {lang("parentChildFacilityMaintenance.name")}{" "}
                                <em className="bx bxs-sort-alt"></em>
                              </div>
                            </th>
                            <th
                              scope="col"
                              onClick={() => handleModalSort("state_name")}
                            >
                              <div className="cursor-pointer">
                                {lang(
                                  "parentChildFacilityMaintenance.prefecture"
                                )}{" "}
                                <em className="bx bxs-sort-alt"></em>
                              </div>
                            </th>
                            <th
                              scope="col"
                              onClick={() => handleModalSort("city_name")}
                            >
                              <div className="cursor-pointer">
                                {lang("parentChildFacilityMaintenance.city")}{" "}
                                <em className="bx bxs-sort-alt"></em>
                              </div>
                            </th>
                            <th
                              scope="col"
                              onClick={() =>
                                handleModalSort("customer_type_name")
                              }
                            >
                              <div className="cursor-pointer">
                                {lang("parentChildFacilityMaintenance.type")}{" "}
                                <em className="bx bxs-sort-alt"></em>
                              </div>
                            </th>
                            <th
                              scope="col"
                              onClick={() => handleModalSort("number_of_beds")}
                            >
                              <div className="cursor-pointer">
                                {lang(
                                  "parentChildFacilityMaintenance.noOfBeds"
                                )}
                                <em className="bx bxs-sort-alt"></em>
                              </div>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {modalFacilitySearchList &&
                            modalFacilitySearchList.map((fac, index) => {
                              return (
                                <tr key={index}>
                                  <td>
                                    <button
                                      className="btn btn-primary"
                                      onClick={() => updateFacility(fac)}
                                    >
                                      {lang("Buttons.select")}
                                    </button>
                                  </td>
                                  <td>{fac && fac.customerCode}</td>
                                  <td>{fac && fac.facilityName}</td>
                                  <td>{fac && fac.state_name_local}</td>
                                  <td>{fac && fac.city_name_local}</td>
                                  <td>{fac && fac.customer_type_name}</td>
                                  <td>{fac && fac.number_of_beds}</td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                    {modalFacilitySearchList.length < modalFacilityTotal && (
                        <div className="steps-action1 mt-4">
                          {modalLazyLoading && <Spinner animation="border" />}
                          <button
                            className="btn btn-primary"
                            onClick={loadModalRecords}
                            disabled={modalLazyLoading}
                          >
                            {lang("Buttons.loadMore")}
                          </button>
                        </div>
                      )}
                  </>
                )}
              {modalLoading === true && <Spinner animation="border" />}
              {noModalData && (
                <div className="noData">{lang("errorMessages.NO_DATA")}</div>
              )}
              <div className="text-right">
                <button className="btn btn-primary" onClick={handleClose}>
                  {lang("Buttons.close")}
                </button>
              </div>
          </Modal>
        </>
      )}
    </Home>
  ) : (
    <p>Page Not found</p>
  );
}

export default ParentChildFacility;
